import Image from "next/image"
import { parseAsString, useQueryState } from "nuqs"
import { SidebarHeader as SidebarHeaderBase, SidebarInput } from "../ui/sidebar"
import { SystemSwitcher } from "./nav-switcher"

export function SidebarHeader({ collapse }: { collapse: boolean }) {
  const [inputSearch, setInputSearch] = useQueryState("sidebar-search", parseAsString.withDefault(""))
  // Sistemas disponibles
  const systems = [
    {
      name: "OVR",
      logo: (
        <Image
          alt="OVR"
          height={16}
          src="/WIN2TEC-GMS.png"
          width={16}
        />
      ),
      description: "On Venue Results",
    },
  ]
  return (
    <SidebarHeaderBase>
      <SystemSwitcher collapse={collapse} systems={systems} />
      { !collapse && (
        <SidebarInput
          onChange={e => void setInputSearch(e.target.value)}
          placeholder="Buscar"
          type="text"
          value={inputSearch}
        />
      ) }
    </SidebarHeaderBase>
  )
}
